import { shorthands } from "@tamagui/shorthands/v2";
import { tokens, themes as themesIn } from "@tamagui/themes/v3-themes";
import { animations } from "./v3-animations.mjs";
import { fonts } from "./fonts.mjs";
import { media, mediaQueryDefaultActive } from "./media.mjs";
import { animations as animations2 } from "./v3-animations.mjs";
import { tokens as tokens2, themes } from "@tamagui/themes/v3-themes";
import { shorthands as shorthands2 } from "@tamagui/shorthands/v2";
import { fonts as fonts2 } from "./fonts.mjs";
import { media as media2, mediaQueryDefaultActive as mediaQueryDefaultActive2 } from "./media.mjs";
globalThis.global ||= globalThis;
const selectionStyles = theme => theme.color5 ? {
    backgroundColor: theme.color5,
    color: theme.color11
  } : null,
  themes2 = process.env.TAMAGUI_OPTIMIZE_THEMES === "true" ? {} : themesIn,
  config = {
    animations,
    defaultFont: "body",
    shouldAddPrefersColorThemes: !0,
    themeClassNameOnRoot: !0,
    themes: themes2,
    media,
    shorthands,
    tokens,
    fonts,
    mediaQueryDefaultActive,
    selectionStyles
  };
export { animations2 as animations, config, fonts2 as fonts, media2 as media, mediaQueryDefaultActive2 as mediaQueryDefaultActive, selectionStyles, shorthands2 as shorthands, themes, tokens2 as tokens };